import { toast } from "sonner";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import CampaignStatusPresetService from "services/CampaignStatusPreset";

const DeleteCampaignStatusPresetModal = ({
  preset,
  open,
  onOpenChange,
  fetchPresets,
}) => {
  const handleConfirm = async () => {
    try {
      await CampaignStatusPresetService.deleteCampaignStatusPreset(preset.id);
      toast.success("Preset deleted");
      onOpenChange(false);
      if (fetchPresets) {
        fetchPresets();
      }
    } catch {
      toast.error("Failed to delete preset");
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete preset?"
      description="Are you sure you want to delete this Campaign Status Preset?"
      onConfirm={handleConfirm}
    />
  );
};

export default DeleteCampaignStatusPresetModal;
